import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { select } from "@angular-redux/store";
import { Observable, Subscription } from "rxjs";
import { PlanningBlock } from "../../../models/planning-block/planning-block.interface";
import { OrderLine } from "../../../models/order-line/orderLine.interface";
import { ShippingLine } from "../../../models/order-line/line.interface";
import { WizardDefinition } from "../../../../shared/models/wizard-definition";
import { ActionWizardService } from "../../../../shared/services/action-wizard.service";
import { PbScreenService } from "../../../services/pb-screen.service";
import { DataStateChangeEvent, GridComponent, GridDataResult, PageChangeEvent, SelectableSettings } from "@progress/kendo-angular-grid";
import { State } from "@progress/kendo-data-query";
import { PbActions } from "../../../pb.actions";
import { OrderlineService } from "../../../../shared/services/orderline.service";
import { SharedActions } from "../../../../shared/shared.actions";
import { ToScreenService } from "../../../services/to-screen.service";
import { PlanningBoardActions } from "../../../../planningBoard/planningBoard.action";
import { SimpleModalComponent } from "ngx-simple-modal";
import { environment } from "../../../../../environments/environment";
import { ToActions } from "../../../../to-screen/to.actions";
import { ApplicationUser } from "../../../models/application.user.interface";
import { DateParserService } from "../../../helpers/date-parser.service";

import * as moment from "moment";
import { UserFeedbackService } from "../../../../services/user-feedback.service";
import { TranslateService } from "@ngx-translate/core";
import { forkJoin } from "rxjs";
import { take } from "rxjs/operators";

@Component({
  moduleId: module.id,
  selector: "pb-insert-action-wizard-modal",
  templateUrl: "./pb-insert-action-wizard-modal.component.html"
})

export class PbInsertActionWizardComponent extends SimpleModalComponent<void, boolean> implements OnInit, OnDestroy {

  @ViewChild("modal", { read: ElementRef }) public modal: ElementRef;
  @select("selectedPlanningBlocks") selectedPlanningBlocks$: Observable<PlanningBlock[]>;
  @select("selectedOrderlines") selectedOrderlines$: Observable<OrderLine[]>;
  @select("selectedActionWizard") selectedActionWizard$: Observable<WizardDefinition>;


  @select("selectedPbsFromPlanBoard") selectedPbsFromPlanBoard$: Observable<PlanningBlock[]>;
  @select("selectedPbsToPlan") public selectedPbsToPlan$: Observable<PlanningBlock[]>;

  @select("selectedOrderlinesFromBoard") selectedOrderlinesFromBoard$: Observable<any[]>;
  @select("pbOrderlines") public pbOrderlines$: Observable<OrderLine[]>;
  @select("loading") public loading$: Observable<boolean>;
  @select("applicationUser") public applicationUser$: Observable<ApplicationUser>;
  public enableAutocomplete: boolean = false;
  public selectedOrderlineId: number;
  public selectedPb: PlanningBlock;
  public selectedPbs: PlanningBlock[];
  public orderlines: OrderLine[] = [];
  public selectedOrderlines: OrderLine[] = [];

  public selectedActionWizard: WizardDefinition;
  public currentStep: number;
  public navigationEnabled: boolean = true;
  public gridData: GridDataResult;
  public wizardLines: any;
  public searchFilter: string = "";
  public selectedWizardLineAddresses = [];

  public shouldAskAdress = false;
  public addressAsked = false;
  public wizardManuallySelectOrderline = true;
  public wizardSelectDateTime = false;

  public wizardResult: any;
  public TimeRequiredArray: PlanningBlock[];

  public selectedRow: number;
  public shipOrRailState: State = {
    skip: 0,
    take: 25,
  };
  public shipOrRailGridData: GridDataResult;

  private _shipRailGrid: GridComponent;
  @ViewChild("shipRailGrid") set shipRailGrid(shipRailGrid: GridComponent) {
    if (shipRailGrid) {
      this._shipRailGrid = shipRailGrid;
    }
  }

  public requestedDateTimeUntil: Date;
  public requestedDateTimeFrom: Date;
  public bookedDateTimeFrom: Date;
  public bookedDateTimeUntil: Date;

  public shipOrRailSelection: ShippingLine[] = [];
  public showShippingOrRailwayLines: boolean = false;
  shipOrRailLines: ShippingLine[] = [];
  selectedShipOrRailLineNo: string;
  railwayEnabled: boolean = environment.railway;
  shippingEnabled: boolean = environment.shipping;


  public selectedWizard = {
    index: 0,
    addressList: []
  };


  public state: State = {
    skip: 0,
  };
  public selectableSettings: SelectableSettings = {
    checkboxOnly: false,
    mode: "single",
  };
  public mySelection: OrderLine[] = [];

  public loadingSpinner: boolean = false;

  private subscriptions: Subscription = new Subscription();

  private user: ApplicationUser;

  constructor(
    private readonly actionWizardService: ActionWizardService,
    private readonly pbScreenService: PbScreenService,
    private readonly userFeedbackService: UserFeedbackService,
    private readonly translateService: TranslateService,
    private readonly pbActions: PbActions,
    public readonly toActions: ToActions,
    private readonly sharedActions: SharedActions,
    private readonly orderlineService: OrderlineService,
    private readonly sharedAction: SharedActions,
    private readonly toScreenService: ToScreenService,
    private readonly planningBoardActions: PlanningBoardActions,
    public readonly dateParserService: DateParserService
  ) {
    super();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngOnInit(): void {
    let subscription;
    this.currentStep = 1;

    subscription = this.loading$.subscribe((data) => {
      if (!data) {
        this.loadingSpinner = data;
      }
    });
    this.subscriptions.add(subscription);

    subscription = this.applicationUser$.subscribe((applicationUser: ApplicationUser) => {
      if (applicationUser) {
        this.enableAutocomplete = applicationUser.generalSetting.enableAutocomplete;
        this.user = applicationUser;
      }
    });
    this.subscriptions.add(subscription);

    subscription = this.selectedPlanningBlocks$.subscribe((planningBlocks) => {
      if (planningBlocks && planningBlocks.length > 0) {
        this.selectedPbs = planningBlocks;
        this.selectedPb = planningBlocks[0];
      }
    });
    this.subscriptions.add(subscription);

    subscription = this.selectedPbsToPlan$.subscribe((planningBlocks) => {
          if (planningBlocks && planningBlocks.length > 0) {
              const prevId = this.selectedPb ? this.selectedPb.id : null;
              this.selectedPbs = planningBlocks;
              this.selectedPb = planningBlocks[0];

              if (this.orderlines.length == 0 || (this.selectedPb && this.selectedPb.id != prevId)) {
                  this.pbScreenService.getPlanningBlockDetails(this.selectedPb).subscribe((data: OrderLine[]) => {
                      this.orderlines = data;
                      this.setGridContent();

                  });
              }
          }
      });
    this.subscriptions.add(subscription);

    subscription = this.selectedPbsFromPlanBoard$.subscribe((planningBlocks) => {
      if (planningBlocks && planningBlocks.length > 0) {
        this.selectedPbs = planningBlocks;
        this.selectedPb = planningBlocks[0];
      }
    });
    this.subscriptions.add(subscription);

    this.pbOrderlines$.subscribe((data) => {
      this.orderlines = data;
      this.setGridContent();
    });

    subscription = this.selectedOrderlinesFromBoard$.subscribe((ol) => {
      if (ol && ol.length > 0) {
        this.pbScreenService.getPlanningBlocksByIds(ol.map(x => x.planningBlockId)).subscribe((pbs) => {
                    const prevId = this.selectedPb ? this.selectedPb.id : null;
          this.selectedPb = pbs[0];
          if (this.selectedPb && this.selectedPb.id != prevId) {
            this.pbScreenService.getPlanningBlockDetails(this.selectedPb).subscribe((data: OrderLine[]) => {
              this.orderlines = data;
              this.setGridContent();

            });
          }
        });
      }
    });
    this.subscriptions.add(subscription);

    subscription = this.selectedActionWizard$.subscribe((actionWizard) => {
      this.selectedActionWizard = actionWizard;
    });
    this.subscriptions.add(subscription);
  }

  getWizardLines() {
    if (this.selectedOrderlineId && this.selectedActionWizard) {
      this.actionWizardService.getWizardLines(this.selectedActionWizard.code, this.selectedOrderlineId).subscribe((res) => {
        this.wizardLines = res;
      });
    }
  }

  getAddressesForWizard(wizardLine) {
    if (this.searchFilter.length >= 3) {
      this.actionWizardService.getAddresses(wizardLine.wizardCode, wizardLine.lineNo, this.searchFilter).subscribe((data) => {
        this.selectedWizard.addressList = data;
      });
    } else {
      this.userFeedbackService.showWarningMessage("INSERT_ACTION_WIZARD_MODAL.PLACEHOLDER_SEARCH_ADDRESS");
    }
  }

  executeWizard(wizardData) {
    this.loadingSpinner = true;

    // Ensure wizardData has orderLineIDs instead of orderLineId
    const updatedWizardData = {
      ...wizardData,
      orderLineIDs: wizardData.orderLineIDs || (wizardData.orderLineId ? wizardData.orderLineId.toString() : "")
    };
    delete updatedWizardData.orderLineId; // Remove old field if present

    this.actionWizardService.executeWizard(updatedWizardData).subscribe((data) => {
      // Test if inserting dateTime for pbs is required
            const timerequiredLine = this.wizardLines.find((x) => x.timeRequired === true);
      if (this.wizardLines.length > 0 && timerequiredLine) {
        this.wizardManuallySelectOrderline = false;
        this.shouldAskAdress = false;
        this.wizardSelectDateTime = true;
        this.currentStep++;

        // Parse all order line IDs and call the method for each
        const orderLineIds = wizardData.orderLineIDs ? wizardData.orderLineIDs.split('|').map(id => parseInt(id)) : [];
        if (orderLineIds.length > 0) {
          // Call getNewSplittedPBAndOLCreatedByIAW for each order line ID
          const pbAndOlObservables = orderLineIds.map(orderLineId =>
            this.actionWizardService.getNewSplittedPBAndOLCreatedByIAW(orderLineId, wizardData.code)
          );

          forkJoin(pbAndOlObservables).subscribe((results: PlanningBlock[][]) => {
            // Flatten all results into a single array
            const allWizardPbs: PlanningBlock[] = results.reduce((acc: PlanningBlock[], result: PlanningBlock[]) => acc.concat(result || []), []);
            this.sharedAction.updatePlanningBlocksDisplay(allWizardPbs, true);
            this.pbActions.setSelectedPlanningBlocks([...this.selectedPbs, ...allWizardPbs], false);
            this.wizardResult = allWizardPbs;
            if (!allWizardPbs || !allWizardPbs.length) {
              this.wizardResult = data.result;
            }

            this.TimeRequiredArray = allWizardPbs;
            this.TimeRequiredArray.forEach(element => {

              element.planningOrderlines.forEach(orderline => {

                this.dateParse(orderline, "requestedDateTimeFrom");
                this.dateParse(orderline, "requestedDateTimeUntil");
                this.dateParse(orderline, "bookedDateTimeFrom");
                this.dateParse(orderline, "bookedDateTimeUntil");


              });

            });
          }, _ => this.wizardResult = data.result);
        }

        // this.actionWizardService.getNewSplittedPBsCreatedByIAW(wizardData.orderLineId, wizardData.code).subscribe((data) => {

        // });

        if (this.selectedPb) {
          this.toScreenService.getTransportOrdersByIds(this.selectedPb.transportOrderNumber).subscribe((data) => {
                    const orderlines = data[0].planningOrderlines;
            this.sharedAction.getOrderlines(orderlines);
            this.planningBoardActions.setSelectionType("transportOrder");
            this.toActions.setSelectedTransportOrders(data);
            this.planningBoardActions.UpdatePlanningDisplay(data);
          });
        }


      } else {
        this.userFeedbackService.showSuccessMessage("SHARED.WIZARD_SAVED", undefined, "SHARED.WIZARD_SAVED_TITLE");
        if (data.result.length > 0) {
          this.selectedPbs = data.result;
        }
        const prevselectedPB = this.selectedPb;
        this.selectedPb = this.selectedPbs[0];

        // Parse all order line IDs and call the method for each
        const orderLineIds = wizardData.orderLineIDs ? wizardData.orderLineIDs.split('|').map(id => parseInt(id)) : [];
        if (orderLineIds.length > 0) {
          // Call getNewSplittedPBsCreatedByIAW for each order line ID
          const pbObservables = orderLineIds.map(orderLineId =>
            this.actionWizardService.getNewSplittedPBsCreatedByIAW(orderLineId, wizardData.code)
          );

          forkJoin(pbObservables).subscribe((results: PlanningBlock[][]) => {
            // Flatten all results into a single array
            const allPbs: PlanningBlock[] = results.reduce((acc: PlanningBlock[], result: PlanningBlock[]) => acc.concat(result || []), []);
            this.sharedAction.updatePlanningBlocksDisplay(allPbs, true);
            this.pbActions.setSelectedPlanningBlocks([...this.selectedPbs, ...allPbs], false);
          });
        }


        this.toScreenService.getTransportOrdersByIds(this.selectedPb.transportOrderNumber).subscribe((data) => {
          const orderlines = data[0].planningOrderlines;
          this.sharedAction.getOrderlines(orderlines);
          this.planningBoardActions.setSelectionType("transportOrder");
          this.toActions.setSelectedTransportOrders(data);
          this.planningBoardActions.UpdatePlanningDisplay(data);

        });

        this.sharedActions.deleteSharedPlanningBlocksDisplay([prevselectedPB]);
        this.sharedActions.updatePlanningBlocksDisplay(data.result , true);

        this.closeModal(true);
      }
      this.loadingSpinner = false;
    }, _ => {
      this.loadingSpinner = false;
      this.closeModal(false);
    });
  }

  // To Do : Update orderlines in result pb (add dateTime)
  async saveDateTimeForPbs() {
    for (const element of this.TimeRequiredArray) {
      for (const ol of element.planningOrderlines) {
        if (ol.requestedDateTimeFrom && !ol.requestedDateTimeUntil) {
          this.userFeedbackService.showErrorMessage("SHARED.ERRORS.REQUESTED_UNTIL_REQUIRED");
          return;
        }
      }
    }

    this.loadingSpinner = true;

    const linesToUpdate = [];
    for (const element of this.TimeRequiredArray) {
      element.planningOrderlines.forEach(lineToSend => {
        lineToSend.bookedDateTimeFrom = moment(lineToSend.bookedDateTimeFrom, "DD-MM-YYYY HH:mm:ss").toDate();
        lineToSend.bookedDateTimeUntil = moment(lineToSend.bookedDateTimeUntil, "DD-MM-YYYY HH:mm:ss").toDate();
        lineToSend.requestedDateTimeFrom = moment(lineToSend.requestedDateTimeFrom, "DD-MM-YYYY HH:mm:ss").toDate();
        lineToSend.requestedDateTimeUntil = moment(lineToSend.requestedDateTimeUntil, "DD-MM-YYYY HH:mm:ss").toDate();

        linesToUpdate.push(lineToSend);
      });

    }


    let res = this.orderlineService.updateOrderlineV2(linesToUpdate, false).subscribe((res) => {
      this.pbScreenService.getPlanningBlocksByIds(this.TimeRequiredArray.map(x => x.id)).subscribe((data) => {
        this.pbActions.updatePlanningBlocksDisplay(data, true);
      });
      this.pbActions.resetPlanningBlocks();
      this.userFeedbackService.showSuccessMessage("SHARED.WIZARD_SAVED", undefined, "SHARED.WIZARD_SAVED_TITLE");
      this.loadingSpinner = false;
      this.closeModal(true);

    }, (err) => {
      this.loadingSpinner = false;
      this.closeModal(true);

      var message = "";
      if (err?.error?.feedback?.length > 0) {
        message = err.error.feedback[0].description;

        forkJoin(
          [
            this.translateService.get("INSERT_ACTION_WIZARD_MODAL.WIZARD_ERROR_TITLE"),
            this.translateService.get("INSERT_ACTION_WIZARD_MODAL.WIZARD_ERROR_MESSAGE_PREFIX")
          ]
        ).pipe(
          take(1)
        ).subscribe(([title, messagePrefix]) => {
          this.userFeedbackService.showErrorMessageWithoutTranslating(`${messagePrefix} ${message}`, title);
        });
      } else {
        this.userFeedbackService.showErrorMessage("SHARED.ERRORS.INTERNAL_SERVER_ERROR", undefined, "INSERT_ACTION_WIZARD_MODAL.WIZARD_ERROR_TITLE");
      }
    });

    this.wizardSelectDateTime = false;
  }


  public previous(): void {
    this.currentStep--;
    this.showShippingOrRailwayLines = false;
  }

  public next(): void {
    if (!this.selectedOrderlineId && this.wizardManuallySelectOrderline) {
      this.userFeedbackService.showErrorMessage("SHARED.ERRORS.PLEASE_SELECT_ORDERLINE");
    } else {
      if (this.wizardLines.length > 0) {
        if (this.selectedActionWizard.useShippingLines || this.selectedActionWizard.useRailWayLines) {
          this.shouldAskAdress = false;
          this.actionWizardService.getFilteredShippingLineList(this.selectedActionWizard.code).subscribe(data => {
            this.showShippingOrRailwayLines = true;
            this.shipOrRailLines = data;
            this.setShipOrRailGridContent();
          }, _ => {
            this.currentStep--;
          });
        // THE ORDER of IFS IS IMPORTANT for takeAddressFromSelectedOL and useSameAddress
                } else if (this.selectedActionWizard.takeAddressFromSelectedOL) {
                  this.selectedWizardLineAddresses.push({
                    lineNo: this.selectedOrderlineId,
                    addressNo: this.selectedOrderlines[0].address.addressNumber
                  });

                  this.shouldAskAdress = false;

                  const dataToSave = {
                    addressList: this.selectedWizardLineAddresses.map((x) => x.addressNo).join(";"),
                    calledFrom: 0,
                    code: this.selectedActionWizard.code,
                    orderLineIDs: this.selectedOrderlineId ? this.selectedOrderlineId.toString() : ""
                  };

                  this.executeWizard(dataToSave);

                  // THE ORDER of IFS IS IMPORTANT for takeAddressFromSelectedOL and useSameAddress
                } else if (this.selectedActionWizard.useSameAddress) {
          if (this.wizardLines[0].addressNo) {
            this.selectedWizardLineAddresses.push({
              lineNo: this.wizardLines[0].lineNo,
              addressNo: this.wizardLines[0].addressNo
            });
            this.shouldAskAdress = false;

            const dataToSave = {
              addressList: this.selectedWizardLineAddresses.map((x) => x.addressNo).join(";"),
              calledFrom: 0,
              code: this.selectedActionWizard.code,
              orderLineIDs: this.selectedOrderlineId ? this.selectedOrderlineId.toString() : ""
            };
            this.executeWizard(dataToSave);
          } else {
            this.shouldAskAdress = true;
          }
        } else {
          this.wizardLines.forEach(element => {
            if (element.addressNo) {
                            const alreadyPushedAdrs = this.selectedWizardLineAddresses.map((x) => x.lineNo === element.lineNo);
              if (alreadyPushedAdrs.length === 0) {
                this.selectedWizardLineAddresses.push({
                  lineNo: element.lineNo,
                  addressNo: element.addressNo
                });
                this.shouldAskAdress = false;
              }
            } else {
              this.shouldAskAdress = true;
            }
          });
        }
      }

      this.currentStep++;
    }
  }

  public pageChange(event: PageChangeEvent): void {
    this.shipOrRailState.skip = event.skip;
    this.setShipOrRailGridContent();
  }

  public saveData(): void {
    if (this.showShippingOrRailwayLines) {
      this.saveShipOrRailData();
      return;
    }
    if (this.shouldAskAdress && this.selectedWizardLineAddresses.length === 0) {
      this.userFeedbackService.showErrorMessage("SHARED.ERRORS.PLEASE_SELECT_ADDRESS");
      return;
    }
    if (!this.selectedActionWizard.useSameAddress && this.shouldAskAdress && this.selectedWizardLineAddresses.length !== this.wizardLines.length) {
      this.userFeedbackService.showErrorMessage("SHARED.ERRORS.PLEASE_SELECT_ADDRESS_FOR_EACH_WIZARD_LINE");
      return;
    } else if (this.shouldAskAdress && !this.addressAsked) {
      if (this.selectedOrderlineId && this.wizardManuallySelectOrderline) {
        this.wizardManuallySelectOrderline = false;
      }
    }

    let dataToSave = {
      addressList: this.selectedWizardLineAddresses.map((x) => x.addressNo).join(";"),
      calledFrom: 0,
      code: this.selectedActionWizard.code,
      orderLineIDs: this.selectedOrderlineId ? this.selectedOrderlineId.toString() : ""
    };

    this.executeWizard(dataToSave);

  }

  private setStep(step): void {
    if (this.navigationEnabled) {
      this.currentStep = step;
    }
  }

  public setGridContent(): void {
    this.gridData = {
      data: [...this.orderlines],
      total: this.orderlines.length,
    };
  }

  public rowClicked(gridUser, selection): void {
    this.selectedOrderlineId = selection[0];
        this.selectedOrderlines = this.gridData.data?.filter(pb => pb.orderLineId === this.selectedOrderlineId);
    this.mySelection = [...selection];
    this.getWizardLines();
  }

  public selectAddress(lineNo, address, index) {
    let selectedAddress = this.selectedWizardLineAddresses.find((x) => x.lineNo === lineNo);
    if (selectedAddress) {
      selectedAddress.addressNo = address.no;
    } else {
      this.selectedWizardLineAddresses.push({
        lineNo: lineNo,
        addressNo: address.no
      });
    }
    this.selectedRow = index;
    this.shouldAskAdress = true;
  }

  public setAddressContent() {
    this.selectedWizard.addressList = [];
    this.searchFilter = "";

    this.bookedDateTimeFrom = null;
    this.bookedDateTimeUntil = null;
    this.requestedDateTimeFrom = null;
    this.requestedDateTimeUntil = null;
  }

  public closeModal(result = false): void {
    this.result = result;
    this.close();
  }

  saveShipOrRailData() {
    if (!this.selectedShipOrRailLineNo) {
      this.userFeedbackService.showErrorMessage("SHARED.ERRORS.PLEASE_SELECT_LINE");
      return;
    }

    this.executeShipOrRailWizard();
  }

  executeShipOrRailWizard() {
    let dataToSave = {
      shippingLineNo: this.selectedShipOrRailLineNo,
      calledFrom: 1,
      code: this.selectedActionWizard.code,
      orderLineIDs: this.selectedOrderlineId ? this.selectedOrderlineId.toString() : ""
    };
    this.executeWizard(dataToSave);
  }

  public shipOrRailRowClicked(gridUser, selection): void {
    this.selectedShipOrRailLineNo = selection[0];
    this.shipOrRailSelection = [...selection];
  }

  public setShipOrRailGridContent(): void {
    this.shipOrRailGridData = {
      data: [...this.shipOrRailLines.slice(this.shipOrRailState.skip, this.shipOrRailState.skip + this.shipOrRailState.take)],
      total: this.shipOrRailLines.length,
    };
    setTimeout(() => {
      if (this._shipRailGrid) {
        this._shipRailGrid.autoFitColumns();
      }
    });
  }


  public dateParse(ol, name) {

    if (moment(ol[name]).year() == 1753) {
      ol[name] = "";
      return;
    }
    var parsedDate = this.dateParserService.parseDate(ol[name]);
    if (moment.isMoment(parsedDate)) {
      ol[name] = parsedDate.format("DD-MM-YYYY HH:mm:ss");
    } else {
      ol[name] = "";
    }
  }

  public getValueToChange(name): any {
    switch (true) {
      case name == "requestedDateTimeFrom":
        return this.requestedDateTimeFrom;
      case name == "requestedDateTimeUntil":
        return this.requestedDateTimeUntil;
      case name == "bookedDateTimeFrom":
        return this.bookedDateTimeFrom;
      case name == "bookedDateTimeUntil":
        return this.bookedDateTimeUntil;

    }
  }


  public assignValueToChange(name, value): any {
    switch (true) {
      case name == "requestedDateTimeFrom":
        this.requestedDateTimeFrom = value;
        return;
      case name == "requestedDateTimeUntil":
        this.requestedDateTimeUntil = value;
        return;
      case name == "bookedDateTimeFrom":
        this.bookedDateTimeFrom = value;
        return;
      case name == "bookedDateTimeUntil":
        this.bookedDateTimeUntil = value;
        return;

    }
  }
  public linesPageChange(event: DataStateChangeEvent): void {
    this.state.skip = event.skip;
    this.setGridContent();
  }
}
